import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router";
import {Observable} from "rxjs";
import {PartnerService} from "../services/partner.service";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class PartnerGuard  {
  constructor(
    private partnerService: PartnerService
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.partnerService.showAnnouncements();
  }
}
